import api from '@/services/api';

const UserContractVersionNameQuery = {
  getUserContractVersionNameList: companyId => {
    return api.get('get_user_contract_version_name_list/', {
      params: {
        companyId: companyId
      }
    });
  },
  getUserContractHeadInfoListForAllVersions: userContractRootId => {
    return api.get(`get_user_contract_head_info_list_for_all_versions/`, {
      params: { user_contract_root_id: userContractRootId }
    });
  }
};

export default UserContractVersionNameQuery;



// WEBPACK FOOTER //
// ./src/api/user_contract/user_contract_version_name/query.js